<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    </div>
</template>

<script>
export default {
  name: 'DrillActionsCellRenderer',
  methods: {
    editRecord () {
      // this.params.data is not refreshed by gridApi
      this.params.context.componentParent.edit(this.params.node.data);
    }
  }
}
</script>
